var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.show)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-container",class:[{ 'modal-container-sm' : _vm.size == 'SMALL' }, _vm.className],on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f9d740b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@microbadevs/report/src/components/models/ModalNoExit.vue
// module id = Q/OE
// module chunks = 1